import { handleActions } from 'redux-actions';
import { tryDeleteWish, clearWishToDelete } from './actions';

const defaultState = {
  wishIdToDelete: null
};

export default handleActions({
  [tryDeleteWish]: (state, { payload: wishId }) => ({ wishIdToDelete: wishId }),
  [clearWishToDelete]: () => defaultState
}, defaultState);



// WEBPACK FOOTER //
// ./src/store/deleteWish/reducer.js